// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const LocationService = {
    /**
     * GetLocation returns a location object for a given location id
     */
    GetLocation(fn, req) {
        try {
            fm.validateUrlParam(req["locationId"], "locationId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/location/v2/data-location/locations/${req["locationId"]}?${fm.renderURLSearchParams(req, ["locationId"])}`, { method: "GET" });
    },
    /**
     * Search Locations returns a list of locations that match the search criteria
     */
    SearchLocations(fn, req) {
        return fn(`/location/v2/data-location/locations/search?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * LocationsInOrg returns a list of locations that are in the given org
     */
    LocationsInOrg(fn, req) {
        try {
            fm.validateUrlParam(req["orgId"], "orgId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/location/v2/data-location/organizations/${req["orgId"]}/locations?${fm.renderURLSearchParams(req, ["orgId"])}`, { method: "GET" });
    },
    /**
     * OrgsFromToken returns a list of orgs that the given token has access to
     * Token is required.  Expected to be HTTP only.
     */
    OrgsFromToken(fn, req) {
        return fn(`/location/v2/data-location/organizations?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
};
